//Devices
export const ALL_DEVICES = 'ALL_DEVICES'

//Saved
export const ADD_SAVED = 'ADD_SAVED'
export const REMOVE_SAVED = 'REMOVE_SAVED'
export const ALL_SAVED = 'ALL_SAVED'
export const DEFAULT_SAVED = 'DEFAULT_SAVED'

//Account
export const GET_ACCOUNT = 'GET_ACCOUNT'
export const GET_FINAL_BALANCE = 'GET_FINAL_BALANCE'
export const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT'
export const SET_TOKEN = 'SET_TOKEN'
export const GET_PROFILE = 'GET_PROFILE'
export const REMOVE_APOLLO_AUTH = 'REMOVE_APOLLO_AUTH'
export const ADD_APOLLO_AUTH = 'ADD_APOLLO_AUTH'

//Hijack
export const SET_HIJACKER = 'SET_HIJACKER'
export const SET_HIJACKED = 'SET_HIJACKED'
export const REVERT_ACCOUNT = 'REVERT_ACCOUNT'
export const REMOVE_HIJACKER = 'REMOVE_HIJACKER'